import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";

export const StyledScoreContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const StyledScoreItem = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const StyledStarsContainer = styled.div`
    display: flex;
    gap: 4px;
`;

export const StyledStarIcon = styled(SWReactIcons)<{ color: string }>`
    svg > polygon {
        fill: ${({ color }: { color: string }) => color};
    }
`;
